import type { RefObject } from "react";
import type {
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import type Reaptcha from "reaptcha";
import FormReCAPTCHA from "./FormReCAPTCHA";

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  rules?: RegisterOptions;
  ref?: RefObject<Reaptcha>;
};

const FormCaptcha = <T extends FieldValues>(props: Props<T>) => (
  <FormReCAPTCHA {...props} />
);

export default FormCaptcha;
